const global = {
	apisUrl: window.location.hostname === 'localhost' ? 'http://localhost:5555/api' : `${window.location.origin}/api`,
	baseUrl: window.location.hostname === 'localhost' ? 'http://localhost:5555/' : `${window.location.origin}/`,
};

export default global;
